var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCryptoEth = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7782 6.25V20.1094L37.4922 25.3437L25.7782 6.25Z",
    fill: "#fff",
    fillOpacity: 0.602
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7781 6.25L14.0625 25.3437L25.7781 20.1094V6.25Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7782 34.3254V43.7426L37.5 27.5254L25.7782 34.3254Z",
    fill: "#fff",
    fillOpacity: 0.602
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7781 43.7426V34.3238L14.0625 27.5254L25.7781 43.7426Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7782 32.1451L37.4922 25.3436L25.7782 20.1123V32.1451Z",
    fill: "#fff",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 25.3436L25.7781 32.1451V20.1123L14.0625 25.3436Z",
    fill: "#fff",
    fillOpacity: 0.602
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCryptoEth);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/crypto_eth.9839d6338838e59b8fc6eaa06e6de83b.svg";